// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"735faee4","213":"4b8ffd86","417":"19b5fa6c","420":"a2cfcb11","448":"55cae476","566":"0d45ad05","586":"3edb351c","631":"4e3afa59","664":"c7175a6c","908":"721bd6ce","910":"326f9942","972":"e606eab2","984":"8d1f3039"}[chunkId] + ".chunk.js";
};